/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramConfigsControllerFindAllQueryResponse } from '../types/TelegramConfigsControllerFindAll.ts';

function getTelegramConfigsFindAllUrl() {
  const res = { method: 'GET', url: `/api/telegram/configs` as const };
  return res;
}

/**
 * {@link /api/telegram/configs}
 */
export async function telegramConfigsFindAll(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramConfigsControllerFindAllQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramConfigsFindAllUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
